export interface CenterStat {
  label: string;
  value: string;
}

export interface CourseTrack {
  id: string;
  label: string;
  items: string[];
}

export interface Center {
  id: string;
  slug: string;
  name: string;
  short: string;
  location: string;
  since: string;
  status: "flagship" | "new";
  /** Hero image for the feature panel — landscape, 16:10 aspect works best. */
  image: string;
  /** A single sentence used in the secondary card. */
  tagline: string;
  /** Two-to-three sentence narrative used in the feature panel. */
  description: string;
  courses: CourseTrack[];
  stats: CenterStat[];
}

const SHARED_COURSES: CourseTrack[] = [
  {
    id: "hand-textile",
    label: "Hand & Textile",
    items: ["Sewing & Stitching", "Block Printing", "Kesri Creations Workshop"],
  },
  {
    id: "computer-it",
    label: "Computer & IT",
    items: [
      "Diploma in Computer Applications",
      "Advanced Diploma in Computer Applications",
      "Diploma in Desktop Publishing",
      "Accounting",
      "Web Design",
      "Graphic Design",
      "Customer Care Executive (Voice & Non-Voice)",
      "Web Developer",
      "Junior Software Developer",
    ],
  },
];

export const centers: Center[] = [
  {
    id: "varanasi",
    slug: "varanasi",
    name: "Varanasi Skills Centre",
    short: "Varanasi",
    location: "Keshripur village, Varanasi, India",
    since: "2020",
    status: "flagship",
    image: "/students/film-10024.jpg",
    tagline:
      "Our flagship centre — where the work began and the community grew up around it.",
    description:
      "Sadafal Education started in Keshripur with one small classroom and a handful of students. Five years on, it’s a year-round campus offering vocational education in sewing, block printing, and computer skills. Most of our 400+ alumni came through this gate first.",
    courses: SHARED_COURSES,
    stats: [
      { label: "Students enrolled", value: "400+" },
      { label: "Established", value: "2020" },
      { label: "Operating", value: "Year-round" },
    ],
  },
  {
    id: "holapur",
    slug: "holapur",
    name: "Holapur Skills Centre",
    short: "Holapur",
    location: "Holapur, Varanasi, India",
    since: "2026",
    status: "new",
    image: "/centers/holapur-banner.jpg",
    tagline:
      "Our newest centre — extending the work into a previously underserved village.",
    description:
      "Holapur is our second permanent centre, extending our work to another village in the Varanasi area. It carries the same model as our flagship — vocational education and skill development for rural youth — adapted to local trades and the needs of the surrounding community. We're now developing hospitality training here with partners in the hotel industry, opening a direct path from the classroom into hotels and resorts.",
    courses: [
      ...SHARED_COURSES,
      {
        id: "hospitality",
        label: "Hospitality — launching",
        items: [
          "Hotel Operations",
          "Food & Beverage Service",
          "Housekeeping",
          "Front Office",
        ],
      },
    ],
    stats: [
      { label: "Status", value: "Newly opened" },
      { label: "Established", value: "2026" },
      { label: "Programs", value: "Launching" },
    ],
  },
];
